import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtils = PhoneNumberUtil.getInstance()
const telephoneRegion = 'IT';


export function validatePhoneNumber(phone: string): boolean {

    if (phone && phone.length > 0) {

        if (!(/^\+?[0-9][0-9 .-]+$/.test(phone))) {
            return false;
        }

        let phoneNumber;
        try {
            phoneNumber = phoneUtils.parseAndKeepRawInput(phone, telephoneRegion);
        } catch (ex) {


            return false;
        }

        if (phoneNumber && phoneUtils.isValidNumber(phoneNumber)) {
            return true;
        }
        return false;
    }

    return false;
}

export function validateEmail(email: string): boolean {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true
    }
    return false
}


export class ContactValidations {

    static contactFormValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if ((control.value as string)?.length == 0) return null
            return ((!validatePhoneNumber(control.value as string)) && (!validateEmail(control.value as string))) ? { invalid: true } : null;
        };
    }
}